import type { Anatomy, VisibilityCondition } from '../types';

export const ANATOMY_EMOJI: Record<Anatomy, string> = {
  vulva: '🌺',
  penis: '🍆',
};

export function getVisibilityEmoji(visibility: VisibilityCondition): string | null {
  if (visibility === 'always') return null;
  if (visibility.includes('penis')) return ANATOMY_EMOJI.penis;
  if (visibility.includes('vulva')) return ANATOMY_EMOJI.vulva;
  return null;
}
